import React from "react";
import { useSelector } from "react-redux";
import {
  selectContract,
  selectContractLoading,
} from "../../../redux/contract/selectors";
import dayjs from "dayjs";
import { NoneSelectedMessage } from "../../common/NoneSelected";
import { useTranslation } from "react-i18next";

function ReadOnlyInput(props) {
  return (
    <>
      <span className={"input-wrapper-label"}> {props.label} </span>
      <span title={props.field?.length > 80 ? props.tooltip : null}>
        {props.date
          ? props.field
            ? dayjs(props.field, "DD/MM/YYYY").format("DD/MM/YYYY")
            : null
          : props.field}
      </span>
    </>
  );
}

function IdentifyLead(props) {
  const { t } = useTranslation();
  const { mode } = props;
  const contract = useSelector(selectContract);
  const loadingContract = useSelector(selectContractLoading);

  const customerInfo = [
    // {label: "Nombre conductor:", field: contract.driverName},
    // {label: "Apellido conductor:", field: contract.driverSurname},
    // {label: "C.Cli:", field: contract.customerCode},
    // {label: "Cliente:", field: contract.customerName, span:2},
    // {label: "Tlf. cliente:", field: contract.customerPhone},

    { label: `${t("Code")}:`, field: contract.customerCode, span: 2 },
    { label: `${t("Customer")}:`, field: contract.customerName, span: 2 },
    //{ label: `${t("Phone")}:`, field: contract.customerPhone },
  ];

  const contractInfo = [
    { label: `Nº ${t("Contract")}:`, field: contract.contractNumber },
    {
      label: `${t("StartDate")} ${t("Contract")}:`,
      field: contract.contractStartDate,
      date: true,
    },
    {
      label: `${t("EndDate")} ${t("Contract")}:`,
      field: contract.contractEndDate,
      date: true,
    },
    //{label: "Fecha terminación:", field: contract.terminationdate, date:true},
    //{label: "Data Fim estimada:", field: contract.estimatedEndDate, date:true},
    // {label: "Neumáticos Contratados:", field: contract.tyresContracted},
    // {label: "Tamaño neumático:", field: contract.tyreSize},
    // {label: "Neumáticos ilimitados:", field: contract.unlimitedTyres},
    // {label: "Tarjeta combustible:", field: contract.gasCard?"Si":"No"},
    // {label: "Vehiculo sustitución:", field: contract.replacementVehicle?"Si":"No"},
    // {label: "Tipo seguro:", field: contract.insuranceType},
    // {label: "Servicio R&E:", field: contract.vipService?"Si":"No"},
  ];

  const vehicleInfo = [
    { label: "Marca:", field: contract.brand },
    { label: "Modelo:", field: contract.model, span: 2 },
    { label: "Nº bastidor:", field: contract.chassisNumber },
    { label: "Período:", field: contract.periodContracted },
    { label: "Distancia:", field: contract.totalKmContracted },
    { label: "No. licencia:", field: contract.licenseNumber },
    { label: "Nombre responsable fl.:", field: contract.flManagerName },
    { label: "Apellido responsable fl.:", field: contract.flManagerSurname },
    { label: "Fin garantía:", field: contract.guaranteeEndDate, date: true },
    { label: "Grupo:", field: contract.groupCode },
    { label: "C.C.:", field: contract.costCenter },
    { label: "Compañía externa:", field: contract.externalCompany },
    { label: "Catalogación vehículo:", field: contract.cataloguing },
    { label: "Canal de venta veh.:", field: contract.saleChanel },
    { label: "Canal vehículo ocasión:", field: contract.voChanel },
  ];

  return (
    <>
      {contract.plate ? (
        <div id="grid-contract-container">
          {mode === "customer" &&
            customerInfo.map((e) => (
              <ReadOnlyInput
                key={e.label}
                label={e.label}
                field={e.field}
                date={e.date}
                tooltip={e.field}
              />
            ))}
          {mode === "contract" &&
            contractInfo.map((e) => (
              <ReadOnlyInput
                key={e.label}
                label={e.label}
                field={e.field}
                date={e.date}
                tooltip={e.field}
              />
            ))}
          {mode === "vehicle" &&
            vehicleInfo.map((e) => (
              <ReadOnlyInput
                key={e.label}
                label={e.label}
                field={e.field}
                date={e.date}
                tooltip={e.field}
              />
            ))}
        </div>
      ) : (
        <NoneSelectedMessage
          message={
            loadingContract !== "succeeded"
              ? t("NoSelectedCustomer")
              : t("NoAssignedCustomer")
          }
        />
      )}
    </>
  );
}

export { IdentifyLead };
